<app-env-info></app-env-info>
<router-outlet></router-outlet>
